module.exports = __webpack_public_path__ + "img/budget.b81d76d7.svg";